export default {
      id: "deco_a-usage",
      viewBox: "0 0 565 565",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco_a-usage",
      toString: function () {
        return this.url;
      }
    }